import React from 'react';  
import styles from './Chat.module.css';  
  
interface Props {  
  onClickExample?: (question: string) => void;  
}  
  
const ConfigBox = ({ onClickExample }: Props) => {  
  const sendExample = (v: string) => {  
    if (onClickExample) {  
      onClickExample(v);  
    }  
  };  
  
  // Example prompts mirror the Thailand merged FAQ (faq_thailand_merged.xlsx):
  // general / pricing / packages / preparation topics. No booking or login
  // examples — booking is disabled for the Thailand deployment.
  const exampleQuesions = [
    "What is NURA Bangkok?",
    "How much is the health screening?",
    "What's included in Nura Men and Nura Women?",
    "Do I need to fast before the screening?",
  ];
  
  return (  
    <div  
      style={{  
        height: "30%",  
        display: "flex",  
        justifyContent: "center",  
        alignItems: "center",  
        backgroundColor: "white",
        width: "100%",  
        padding: "20px",  
        boxSizing: "border-box",
        marginTop: "20px"
      }}  
    >  
      <div  
        style={{  
          fontStyle: 'normal',  
          fontWeight: 400,  
          backgroundColor: "white",  
          width: "100%",  
          height: "150px",  
          padding: "5px",  
          boxSizing: "border-box",  
          border: "1px solid white",  
          borderRadius: "8px",
          textAlign: "center",
        }}  
      >  
        <div  
          style={{  
            lineHeight: "3",  
            wordBreak: "break-word"  
          }}  
        >  
          {exampleQuesions.map(v => (  
            <span  
              className={styles.questionExample}  
              role="button"  
              onClick={() => sendExample(v)}  
              key={v}  
              style={{  
                display: "inline-block",  
                margin: "0 2px",  
                whiteSpace: "nowrap"  ,
                fontSize: "12px",
              }}  
            >  
              {v}  
            </span>  
          ))}  
        </div>  
        <div  
          style={{  
            margin: "5px",  
            textAlign: "center",  
            fontWeight: 200,  
            fontSize: "12px",  
          }}  
        >  
          Please inform us (<strong>hello@nurathailand.com</strong>) when you find incorrect responses.
        </div>  
      </div>  
    </div>  
  );  
};  
  
export default ConfigBox;  
